import React, { useState } from "react";
import { FaFish, FaStore, FaConciergeBell, FaUtensils } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";

const models = [
  { name: "United", category: "Multi decks", image: "images/united.png", description: "Compact multi-deck display unit designed for optimal space utilization and accessibility.", route: "/United" },
  { name: "Futuro", category: "Display", image: "images/futurofish.jpg", description: "A sleek display unit designed to keep your fish & seafood fresh and visible to customers.", route: "/FUTUROFISH" },
  { name: "Columbus", category: "Display", image: "images/columbus.jpg", description: "Stylish and modern, this display unit offers easy access to fish and seafood products.", route: "/Columbus-lower" },
  { name: "Futuro Expo", category: "Islands", image: "images/futuroexpo1.jpg", description: "A spacious and elegant island display perfect for large seafood presentations.", route: "/FUTUROEXPO" },
  { name: "Futuro Island", category: "Islands", image: "images/futuruisland2.png", description: "A premium island display, ideal for showcasing fish & seafood in a visually appealing manner.", route: "/FUTUROISLAND" },
  { name: "Click & Collect", category: "Intelligent Solutions", image: "images/clickcollect.png", description: "Efficient click-and-collect solution for fish & seafood, enhancing customer experience.", route: "/CLICK&COLLECT" },

];



const icons = [
  { name: "Fish", icon: <FaFish /> },
  { name: "Store", icon: <FaStore /> },
  { name: "Service", icon: <FaConciergeBell /> },
  { name: "Utensils", icon: <FaUtensils /> },
];

function Fishseafood() {
  const [currentPage, setCurrentPage] = useState(1);
  const modelsPerPage = 6;
  const navigate = useNavigate();

  // Get the current models for the current page
  const indexOfLastModel = currentPage * modelsPerPage;
  const indexOfFirstModel = indexOfLastModel - modelsPerPage;
  const currentModels = models.slice(indexOfFirstModel, indexOfLastModel);

  // Handle page change
  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate total pages
  const totalPages = Math.ceil(models.length / modelsPerPage);

  return (
    <div className="w-full font-thin">
      {/* Hero Section */}
      <section
        className="relative text-center w-full h-[600px]"
        style={{
          backgroundImage: "url('images/fishland1.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
       
      </section>

      {/* Models Display */}
      <section className="px-6 py-12 md:px-32">
        <section className="px-6 md:px-32">
        <div className="flex flex-col items-center justify-center text-black p-6">
          <h1 className="text-3xl mb-4 md:text-4xl text-center">Fish & Seafood</h1>
          <p className="text-lg max-w-2xl text-center md:text-2xl text-gray-500">
          Fish is fresh…, salted, frozen or chilled, DSGO have displays units for all kinds of fish and seafood.
          </p>
        </div>

        <div className="flex justify-center">
          <Link to="/" className="block py-1 pl-4 hover:underline mt-6">Home -</Link>
          <button className="block py-1 pl-4 hover:underline uppercase mt-6">Fish & Seafood</button>
        </div>
      </section>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {currentModels.map((model, index) => (
            <div key={index} onClick={() => navigate(model.route)} className="text-center cursor-pointer">
              <div
                className="relative w-full h-80 mb-4"
                style={{
                  backgroundImage: `url(${model.image})`,
                  backgroundSize: "contain", // Ensures no cuts, full image shown
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  height: "300px",
                }}
              ></div>
              <h3 className="text-3xl uppercase font-thin mb-2">{model.name}</h3>
              {/* <p className="text-xl opacity-80 ">{model.category}</p> */}
              <p className="text-xl text-gray-500 max-w-sm opacity-80 mb-4 mx-auto">{model.description}</p>

              {/* Small icons under each model */}
              <div className="flex justify-center gap-4">
                {icons.map((icon, index) => (
                  <div key={index} className="text-2xl">
                    {icon.icon}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Pagination */}
        <div className="flex justify-center mt-10">
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className="px-4 py-2 bg-gray-800 text-white rounded-l"
          >
            Previous
          </button>
          <span className="px-4 py-2">{`Page ${currentPage} of ${totalPages}`}</span>
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="px-4 py-2 bg-gray-800 text-white rounded-r"
          >
            Next
          </button>
        </div>
      </section>
    </div>
  );
}

export default Fishseafood;

// import React, { useState } from "react";
// import { FaFish, FaStore, FaConciergeBell, FaUtensils } from "react-icons/fa";

// const models = [
//   { name: "Futuro", category: "Display", image: "images/futuronew.jpg", description: "A sleek display unit designed to keep your fish & seafood fresh and visible to customers." },
//   { name: "Columbus", category: "Display", image: "images/columbus.jpg", description: "Stylish and modern, this display unit offers easy access to fish and seafood products." },
//   { name: "Click & Collect", category: "Intelligent Solutions", image: "images/clickcollect.png", description: "Efficient click-and-collect solution for fish & seafood, enhancing customer experience." },
//   { name: "Futuro Island", category: "Islands", image: "images/futuruisland2.png", description: "A premium island display, ideal for showcasing fish & seafood in a visually appealing manner." },
//   { name: "Futuro Expo", category: "Islands", image: "images/futuroexpo1.jpg", description: "A spacious and elegant island display perfect for large seafood presentations." },
//   { name: "United", category: "Multi decks", image: "images/united.png", description: "Compact multi-deck display unit designed for optimal space utilization and accessibility." },
// ];

// const icons = [
//   { name: "Fish", icon: <FaFish /> },
//   { name: "Store", icon: <FaStore /> },
//   { name: "Service", icon: <FaConciergeBell /> },
//   { name: "Utensils", icon: <FaUtensils /> },
// ];

// function Fishseafood() {
//   const [currentPage, setCurrentPage] = useState(1);
//   const modelsPerPage = 6;

//   // Get the current models for the current page
//   const indexOfLastModel = currentPage * modelsPerPage;
//   const indexOfFirstModel = indexOfLastModel - modelsPerPage;
//   const currentModels = models.slice(indexOfFirstModel, indexOfLastModel);

//   // Handle page change
//   const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

//   // Calculate total pages
//   const totalPages = Math.ceil(models.length / modelsPerPage);

//   return (
//     <div className="w-full">
//       {/* Hero Section */}
//       <section
//         className="relative text-center w-full h-screen"
//         style={{
//           backgroundImage: "url('images/fishland1.jpg')",
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//           backgroundRepeat: "no-repeat",
//         }}
//       >
//         <div className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-50 text-white p-6">
//           <h1 className="text-4xl font-bold mb-4 md:text-8xl">Fish & Seafood</h1>
//           <p className="text-lg max-w-2xl md:text-3xl">
//             Discover our specialized models for displaying fish & seafood, offering both practicality and elegance.
//           </p>
//         </div>
//       </section>

//       {/* Models Display */}
//       <section className="px-6 py-12 md:px-32">
//         <h2 className="text-4xl md:text-7xl font-bold text-center mb-10">Our Fish & Seafood Models</h2>

//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
//           {currentModels.map((model, index) => (
//             <div key={index} className="text-center">
//               <div
//                 className="relative w-full h-80 mb-4"
//                 style={{
//                   backgroundImage: `url(${model.image})`,
//                   backgroundSize: "contain", // Ensures no cuts, full image shown
//                   backgroundPosition: "center",
//                   backgroundRepeat: "no-repeat",
//                   height: "300px",
//                 }}
//               ></div>
//               <h3 className="text-2xl font-semibold mb-2">{model.name}</h3>
//               <p className="text-sm opacity-80">{model.category}</p>
//               <p className="text-sm max-w-sm opacity-80 mb-4 mx-auto">{model.description}</p>

//               {/* Small icons under each model */}
//               <div className="flex justify-center gap-4">
//                 {icons.map((icon, index) => (
//                   <div key={index} className="text-2xl">
//                     {icon.icon}
//                   </div>
//                 ))}
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Pagination */}
//         <div className="flex justify-center mt-10">
//           <button
//             onClick={() => handlePageChange(currentPage - 1)}
//             disabled={currentPage === 1}
//             className="px-4 py-2 bg-gray-800 text-white rounded-l"
//           >
//             Previous
//           </button>
//           <span className="px-4 py-2">{`Page ${currentPage} of ${totalPages}`}</span>
//           <button
//             onClick={() => handlePageChange(currentPage + 1)}
//             disabled={currentPage === totalPages}
//             className="px-4 py-2 bg-gray-800 text-white rounded-r"
//           >
//             Next
//           </button>
//         </div>
//       </section>
//     </div>
//   );
// }

// export default Fishseafood;
